"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotificationOffset = getNotificationOffset;
exports.useNotificationSystem = exports.NotificationSystemProvider = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _core = require("@commerce-ui/core2");
var _useWindowSize = _interopRequireDefault(require("@commerce-ui/core2/useWindowSize"));
var _uniqueId = _interopRequireDefault(require("@commerce-ui/core2/uniqueId"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NotificationsContext = /*#__PURE__*/_react["default"].createContext({});

// TODO: make alerts visually-hidden instead of removing from DOM
// TODO: make it possible to show notification into ref

// notificationSystemOffset
// notificationSystemOffsetX notificationSystemOffsetY, notificationSystemMenuOffsetY notificationSystemMenuOffsetX

function getNotificationOffset(theme) {
  var s = theme.space;
  var top = {
    x: s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  var bottom = {
    x: s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  var topMenu = {
    x: s.notificationSystemOffsetMenuX || s.notificationSystemOffsetMenu || s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetMenuY || s.notificationSystemOffsetMenu || s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  return {
    top: top,
    bottom: bottom,
    topMenu: topMenu
  };
}
var NotificationSystemProvider = function NotificationSystemProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(false),
    mounted = _useState[0],
    setMounted = _useState[1];
  var _useResponsiveHelpers = (0, _core.useResponsiveHelpers)(),
    currentValue = _useResponsiveHelpers.currentValue;
  var _useState2 = (0, _react.useState)([]),
    notifications = _useState2[0],
    setNotifications = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    isLayerOpen = _useState3[0],
    setLayerOpen = _useState3[1];
  var _close = function close(notificationToClose) {
    setNotifications(function (notifications) {
      return notifications.filter(function (notification) {
        return notification.id !== notificationToClose.id;
      });
    });
  };
  (0, _react.useEffect)(function () {
    window.window.__cui_notificationSystemSetLayerOpen = function (isOpen) {
      // We do it this way so that Layer doesn't have to import MenuLayout if not needed (code split!)
      setLayerOpen(isOpen);
    };
  }, []);
  var show = function show(config) {
    var id = config.id || (0, _uniqueId["default"])();
    var index = notifications.findIndex(function (notification) {
      return notification.id === id;
    });
    if (index > -1) {
      clearTimeout(notifications[index].timeout);
    }
    var newNotification = _objectSpread(_objectSpread({}, config), {}, {
      id: id
    });
    if (typeof config.timeout === "number" && config.timeout > 0) {
      newNotification.timeout = setTimeout(function () {
        _close(newNotification);
      }, config.timeout);
    }
    if (index > -1) {
      var newNotifications = (0, _toConsumableArray2["default"])(notifications);
      newNotifications[index] = newNotification;
      setNotifications(newNotifications);
    } else {
      setNotifications(function (notifications) {
        return [].concat((0, _toConsumableArray2["default"])(notifications), [newNotification]);
      });
    }
  };
  (0, _react.useEffect)(function () {
    setMounted(true);
  }, []);
  var _ = (0, _useWindowSize["default"])(); // unused but rerenders on resize

  var portals;
  if (mounted) {
    var topLeft = [];
    var topRight = [];
    var topMobile = [];
    var topLeftMenu = [];
    var topRightMenu = [];
    var topMobileMenu = [];
    var bottomLeft = [];
    var bottomRight = [];
    var bottomMobile = [];
    var refs = new Map();
    notifications.forEach(function (notification) {
      var placement = currentValue(notification.placement); // TODO: this function can't use hook!!!

      var content = typeof notification.content === "function" ? notification.content({
        close: function close() {
          _close(notification);
        }
      }) : notification.content;

      // TODO: accessibility!!
      content = __jsx(_Box["default"], {
        sx: {
          display: "contents"
        },
        role: "alert",
        key: notification.id
      }, content);
      if (typeof placement === "string") {
        // Menu placement is replaced by standard placement when dialogs are open
        if (placement === "topLeftMenu" && isLayerOpen) {
          placement = "topLeft";
        } else if (placement === "topRightMenu" && isLayerOpen) {
          placement = "topRight";
        }
        if (placement === "topLeft") {
          topLeft.push(content);
          topMobile.push(content);
        } else if (placement === "topRight") {
          topRight.push(content);
          topMobile.push(content);
        } else if (placement === "bottomLeft") {
          bottomLeft.push(content);
          bottomMobile.push(content);
        } else if (placement === "bottomRight") {
          bottomRight.push(content);
          bottomMobile.push(content);
        } else if (placement === "topLeftMenu") {
          topLeftMenu.push(content);
          topMobileMenu.push(content);
        } else if (placement === "topRightMenu") {
          topRightMenu.push(content);
          topMobileMenu.push(content);
        } else {
          throw new Error("unknown position " + placement + " for notification");
        }
      } else {
        if (!placement.current) {
          throw new Error("placement for notification can be either string with position (topLeft, topRight, etc...) or ref");
        }
        if (refs.has(placement.current)) {
          refs.set(placement.current, [].concat((0, _toConsumableArray2["default"])(refs.get(placement.current)), [content]));
        } else {
          refs.set(placement.current, [content]);
        }
      }
    });
    portals = [/*#__PURE__*/_reactDom["default"].createPortal(topLeftMenu, document.getElementById("__notifications-menu-topLeft__") || document.getElementById("__notifications-topLeft__")), /*#__PURE__*/_reactDom["default"].createPortal(topRightMenu, document.getElementById("__notifications-menu-topRight__") || document.getElementById("__notifications-topRight__")), /*#__PURE__*/_reactDom["default"].createPortal(topMobileMenu, document.getElementById("__notifications-menu-topMobile__") || document.getElementById("__notifications-topMobile__")), /*#__PURE__*/_reactDom["default"].createPortal(topLeft, document.getElementById("__notifications-topLeft__")), /*#__PURE__*/_reactDom["default"].createPortal(topRight, document.getElementById("__notifications-topRight__")), /*#__PURE__*/_reactDom["default"].createPortal(topMobile, document.getElementById("__notifications-topMobile__")), /*#__PURE__*/_reactDom["default"].createPortal(bottomLeft, document.getElementById("__notifications-bottomLeft__")), /*#__PURE__*/_reactDom["default"].createPortal(bottomRight, document.getElementById("__notifications-bottomRight__")), /*#__PURE__*/_reactDom["default"].createPortal(bottomMobile, document.getElementById("__notifications-bottomMobile__"))];
    refs.forEach(function (value, keyRef) {
      portals.push(/*#__PURE__*/_reactDom["default"].createPortal(value, keyRef));
    });
  }
  return __jsx(NotificationsContext.Provider, {
    value: {
      show: show
    }
  }, children, portals);
};

// export function Notifications
exports.NotificationSystemProvider = NotificationSystemProvider;
var useNotificationSystem = function useNotificationSystem() {
  return (0, _react.useContext)(NotificationsContext);
};
exports.useNotificationSystem = useNotificationSystem;